import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';

import type { ProposalTileType } from 'modules/proposal/types/ProposalTile.type';

import './proposal-tile-metric.scss';

type Props = {
  type: ProposalTileType,
  label: string,
  value: string,
  tooltip?: string
};

const ProposalMetric = ({ type, label, value, tooltip }: Props): JSX.Element => {
  const metricClassNames = classnames('proposal-tile-metric', `proposal-tile-metric--${type}`);

  return (
    <div className={metricClassNames}>
      <div className="proposal-tile-metric__value">
        {value}
      </div>

      <div className="proposal-tile-metric__label">
        {label}

        {Boolean(tooltip) && (
          <Tooltip
            classNameWrapper="proposal-tile-metric__tooltip"
            message={tooltip}
            width="long"
            showQuestionMark
          />
        )}
      </div>
    </div>
  );
};

export default ProposalMetric;
